import { MessageDescriptor, MessageFormatElement } from "react-intl";
import { enUS, es, ja, type Locale } from "date-fns/locale";

export enum SupportedLocale {
  English = "en",
  Japanese = "ja",
  Spanish = "es",
}

export const LANGUAGE_NAMES: Record<SupportedLocale, string> = {
  [SupportedLocale.English]: "English",
  [SupportedLocale.Spanish]: "Español",
  [SupportedLocale.Japanese]: "日本語",
};

export const DATE_FNS_LOCALES: Record<SupportedLocale, Locale> = {
  [SupportedLocale.English]: enUS,
  [SupportedLocale.Japanese]: ja,
  [SupportedLocale.Spanish]: es,
};

export type TranslationDiff = {
  toTranslate: Record<
    string,
    {
      message: MessageDescriptor;
      locales: SupportedLocale[];
    }
  >;
  toRemove: Record<SupportedLocale, string[]>;
};

// FormatJS-specific helper types (for extracted/compiled locale JSONs)
export type ExtractedMessages = {
  [key: string]: MessageDescriptor;
};
export type CompiledMessages = {
  [key: string]: MessageFormatElement[];
};

// TranslatorClient types
export interface TranslatorClient {
  /**
   * Translates a single text string to the target language.
   *
   * @param text - The text to translate
   * @param targetLang - The target language code (e.g. "FR", "DE")
   * @param context - Optional context to improve translation accuracy
   * @returns Promise containing the translated text
   */
  translate(
    text: string,
    targetLang: string,
    context?: string,
  ): Promise<string>;
  getMetrics(): TranslationMetrics;
}
export type DeepLRequestBody = {
  text: string[];
  source_lang: string;
  target_lang: string;
  context?: string;
  show_billed_characters: boolean;
};
export type TranslationMetrics = {
  requestCount: number;
  successCount: number;
  failureCount: number;
};

export interface FileSystem {
  readFile(path: string): string;
  writeFile(path: string, data: string): void;
  exists(path: string): boolean;
  mkdir(path: string, options: { recursive: boolean }): void;
}
